import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Hero } from "@/components/home/Hero";
import { VisibilitySlider } from "@/components/home/VisibilitySlider";
import { Manifesto } from "@/components/home/Manifesto";
import { Industries } from "@/components/home/Industries";
import { WhatWeBuild, Process } from "@/components/home/WhatWeBuild";
import { PricingSection } from "@/components/home/PricingSection";
import { SelectedWork } from "@/components/home/SelectedWork";
import { Testimonials, FaqSection } from "@/components/home/FaqSection";
import { Marquee, FinalCTA } from "@/components/home/Extras";
import { useContent } from "@/context/ContentContext";

export default function Home() {
  const { hash } = useLocation();
  const { content } = useContent();

  useEffect(() => {
    const seo = content?.seo?.home;
    document.title = seo?.title || "Bezalel Visionary — Web & App Development · Dubai, Sharjah, UAE";
    if (seo?.description) {
      document.querySelector('meta[name="description"]')?.setAttribute("content", seo.description);
    }
    if (hash) {
      setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth" }), 150);
    }
  }, [hash, content]);

  return (
    <main data-testid="home-page">
      <Navbar />
      <Hero />
      <Marquee />
      <WhatWeBuild />
      <Industries />
      <Manifesto />
      <VisibilitySlider />
      <SelectedWork />
      <Process />
      <PricingSection />
      <Testimonials />
      <FaqSection />
      <FinalCTA />
      <Footer />
    </main>
  );
}
